import { CoordinatorService } from "./coordinator.service"

export type STPAR = {
    "font-weight"?: string
    "font-style"?: string
    "font-family"?: string
    "text-decoration"?: string
    "text-transform"?: string
    color?: string
    background?: string
}

export type SGPAR = {
    id?: string
    ownerId?: string
    style: STPAR
}

export class StyleGroup {
    [key: string]: any; 
    id: string
    ownerId: string
    private _params?: any

    constructor(private coords: CoordinatorService, params: SGPAR) {
        this.id = params.id || this.coords.uniqueId()
        this.ownerId = params.ownerId || this.coords.user$.currentId
        this._params = params.style
    }

    get css() {
        return Object.keys(this._params!)
            .map(k => `${k}:${this._params![k]}`)
            .join("; ")
    }

    invertColors() {
        const c = this.color
        const b = this.background
        this.color = b
        this.background = c
    }

    get bold() {
        return !!this._params!["font-weight"]
    }

    set bold(val) {
        if (val)
            this._params!["font-weight"] = "bold"
        else
            delete this._params!["font-weight"]
        this._change()
    }

    get italic() {
        return !!this._params!["font-style"]
    }

    set italic(val) {
        if (val)
            this._params!["font-style"] = "italic"
        else
            delete this._params!["font-style"]
        this._change()
    }

    get underline() {
        return !!this._params!["text-decoration"]
    }

    set underline(val) {
        if (val)
            this._params!["text-decoration"] = "underline"
        else
            delete this._params!["text-decoration"]
        this._change()
    }

    get uppercase() {
        return !!this._params!["text-transform"]
    }

    set uppercase(val) {
        if (val)
            this._params!["text-transform"] = "uppercase"
        else
            delete this._params!["text-transform"]
        this._change()
    }

    get monospace() {
        return !!this._params!["font-family"]
    }

    set monospace(val) {
        if (val)
            this._params!["font-family"] = "monospace"
        else
            delete this._params!["font-family"]
        this._change()
    }


    get color() {
        return this._params!.color
    }

    set color(val) {
        this._params!.color = val
        this._change()
    }

    get background() {
        return this._params!.background
    }

    set background(val) {
        this._params!.background = val
        this._change()
    }

    update(params: STPAR) {
        this._params = params
        this._change()
    }

    updateFromStyleGroup(grp: StyleGroup) {
        this._params = Object.assign({}, grp._params)
        this._change()
    }

    clone(styleId?: string) {
        if (styleId === "_keepId")
            styleId = this.id
        return new StyleGroup(this.coords,
            { id: styleId, style: Object.assign({}, this._params) })
    }

    save(): SGPAR {
        return { id: this.id, style: Object.assign({}, this._params) }
    }

    private _change() {
        this.coords.display$.markForCheck()
    }
}
